import { showNotification } from 'sonata-react-components';

import { createPixel, updatePixel as updatePixelService } from '@/services/pixel.service';

import type { IntlFormatters } from 'react-intl';
import type { Pixel } from 'sonata-static-storage/lib/schemas/pixel/pixel.schema';
import type { Token } from '@/services/common.types';

export async function updatePixel(
  pixelConfig: Pixel,
  formatMessage: IntlFormatters['formatMessage'],
  token: Token
): Promise<void> {
  try {
    await updatePixelService(pixelConfig, token);
    showNotification(
      'info',
      formatMessage({
        defaultMessage: 'The pixel has been updated successfully.',
        id: 'menu.newPixel.updated'
      })
    );
  } catch (_) {
    showNotification(
      'error',
      formatMessage({
        defaultMessage: 'An error occurred while updating the pixel. Please try again.',
        id: 'menu.newPixel.errorUpdating'
      })
    );
  }
}

export async function savePixel(
  pixelConfig: Partial<Pixel>,
  userId: string,
  formatMessage: IntlFormatters['formatMessage'],
  token: Token
): Promise<void> {
  try {
    await createPixel(pixelConfig, userId, token);
    showNotification(
      'info',
      formatMessage({
        defaultMessage: 'The pixel has been created successfully.',
        id: 'menu.newPixel.created'
      })
    );
  } catch (_) {
    showNotification(
      'error',
      formatMessage({
        defaultMessage: 'An error occurred while creating the pixel. Please try again.',
        id: 'menu.newPixel.errorCreating'
      })
    );
  }
}
